const SAFE_LINK_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:']

/**
 * Segunda barreira do esquema de `external_link`. A api recusa `javascript:` e
 * `data:` na gravação, mas o valor vira `href` — ou argumento de
 * `window.location.replace`, nas páginas custom — em tela pública de
 * participante, e o mesmo cuidado que se dá ao HTML vale para o link.
 *
 * Devolve `undefined` quando o link não é utilizável, para o chamador renderizar
 * sem link em vez de emitir um `href` perigoso.
 */
export const safeHref = (link?: string | null): string | undefined => {
  const value = link?.trim()
  if (!value) return undefined

  try {
    const base =
      typeof window === 'undefined' ? 'http://localhost' : window.location.origin
    const parsed = new URL(value, base)

    return SAFE_LINK_PROTOCOLS.includes(parsed.protocol) ? value : undefined
  } catch {
    return undefined
  }
}
